import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  getItem(localStorageKey: string) {
    return localStorage.getItem(localStorageKey);
  }

  setItem(localStorageKey: string, localStorageValue: string) {
    localStorage.setItem(localStorageKey, localStorageValue);
  }

  removeItem(localStorageKey: string) {
    localStorage.removeItem(localStorageKey);
  }

  removeItems(localStorageKeys: Array<string>) {
    localStorageKeys.map(this.removeItem, this);
  }

  removeAllItems() {
    localStorage.clear();
  }
}
